export function disabledFromPeriod(period) {
  return (date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (date > today) return true
  
    if (period.to == null) return false
  
    const to = new Date(period.to)
    to.setHours(0, 0, 0, 0)
  
    if (date > to) return true
  
    return false
  }
}

export function disabledToPeriod(period) {
  return (date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (date > today) return true

    if (period.from == null) return false

    const from = new Date(period.from)
    from.setHours(0, 0, 0, 0)

    if (date < from) return true

    return false
  }
}